const UserProfileKeys = {
  all: ['UserProfiles'] as const,
  lists: () => [...UserProfileKeys.all, 'list'] as const,
  list: (queryParams: string) => [...UserProfileKeys.lists(), { queryParams }] as const,
  details: () => [...UserProfileKeys.all, 'detail'] as const,
  detail: (id: string) => [...UserProfileKeys.details(), id] as const,
};

export { UserProfileKeys };
